// ▶ A janela de confirmacao PROPRIA do app. Ate 24/09/2026 todas as perguntas
// ("Excluir este produto?", "Inativar ...?") usavam a janela do celular
// (window.confirm), que sempre mostra o endereco do site em cima --
// "192.168.15.3:5175 diz..." / "app.crmeunegocio.com.br diz...". Ela achou
// feio no teste da ficha e escolheu trocar nas 6 telas.
//
// Quem pergunta chama `confirmar(...)` e espera a resposta; quem desenha e a
// JanelaConfirmacao, montada UMA vez no App. Um ouvinte so: existe uma janela.

export interface Pergunta {
  texto: string
  // O botao de seguir. "OK" por padrao: os textos longos da importacao dizem
  // literalmente "OK importa assim mesmo".
  botao: string
  // Vermelho: excluir, descartar -- o que nao se desfaz.
  perigo: boolean
  responder: (sim: boolean) => void
}

let ouvinte: ((p: Pergunta) => void) | null = null

export function ouvirPerguntas(fn: (p: Pergunta) => void): () => void {
  ouvinte = fn
  return () => {
    if (ouvinte === fn) ouvinte = null
  }
}

export function confirmar(
  texto: string,
  opcoes: { botao?: string; perigo?: boolean } = {},
): Promise<boolean> {
  // Sem janela montada (nao deveria acontecer): a do celular, e nunca um
  // "nao" calado -- sumir com a pergunta faria o botao parecer quebrado.
  if (ouvinte === null) return Promise.resolve(window.confirm(texto))
  const avisar = ouvinte
  return new Promise((resolve) => {
    avisar({ texto, botao: opcoes.botao ?? 'OK', perigo: opcoes.perigo ?? false, responder: resolve })
  })
}
